import { DatePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldDataType } from '../../../../../sic-lib/enums/FieldDataType';
import { ConversationGridFiltersActions } from '../../../../../sic-lib/reducers/conversationGridFiltersReducer';

const useStyles = makeStyles()({
    root: {
        '& input': {
            /* matching padding toTextField size attribute 'small' */
            paddingTop: '10.5px',
            paddingBottom: '10.5px',
        },
    },
});

const labels: Record<'value' | 'value2', string> = {
    value: 'Start Date',
    value2: 'End Date',
};

interface ComponentState {
    value: any;
    label: string;
}

type Props = {
    /* TIP: fieldName property will be used as the object key in the onChangeHandler reducer */
    fieldName: keyof typeof labels;
    fieldId: number;
    fieldType: FieldDataType;
    fieldValue: string;
    operand: string;
    formDispatch: React.Dispatch<ConversationGridFiltersActions>;
    error: boolean;
    helperText: string;
};

export default function FilterFastField({
    fieldId,
    fieldType,
    fieldName,
    fieldValue,
    operand,
    formDispatch,
    error,
    helperText,
}: Props) {
    const { classes } = useStyles();

    const [inputLabel, setInputLabel] = React.useState<string>('Search');

    React.useEffect(() => {
        setInputLabel(operand === 'between' ? labels[fieldName] : 'Search');
    }, [fieldType, operand, fieldName]);

    const handleChange = (date: DateTime | null) => {
        formDispatch({
            type: 'MODIFY_FORM_FILTER',
            fieldId: fieldId,
            condition: {
                [fieldName]: date ? date.toISO() : '',
            },
        });
    };

    return (
        <DatePicker
            slotProps={{
                textField: {
                    variant: 'outlined',
                    name: inputLabel,
                    label: inputLabel,
                    error: error,
                    helperText: helperText,
                    size: 'small',
                },
            }}
            value={DateTime.fromISO(fieldValue)}
            format="yyyy/MM/dd"
            onChange={handleChange}
        />
    );
}
